import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { ExportTableService } from '../../services/export-table.service';

import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { CalendarService } from '../../services/calendar.service';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';
import { ChartsService } from '../../services/charts.service';
import { Router } from '@angular/router';
import { ChartConfiguration,ChartType, ChartTypeRegistry} from 'chart.js';


interface IRow {
  id: number;
  name: string;
  category: string;
  numOfSold: number;
  total: number;
}
interface primeNgCol {
  field: string;
  header: string;
}
type MyChartTypeRegistry = {
  bar: ChartType;
  line: ChartType;
  radar: ChartType;
  // ... other chart types
};

@Component({
  selector: 'app-service-report',
  templateUrl: './service-report.page.html',
  styleUrls: ['./service-report.page.scss'],
})
export class ServiceReportPage implements OnInit {
  //@ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public stats: Array<IRow>;

  public export: any[];

  public cols: primeNgCol[];

  public columns: any[];

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public wordCloudData: CloudData[] = [];

  public options: CloudOptions = {
    height: 300,
    overflow: false,
  };

  public yearIndicator: boolean = false;

  public xAxisDateChanger: string;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;

  public barChartType: keyof MyChartTypeRegistry = 'bar';

  public barChartLegend: boolean = true;
  public barChartLabels: string[] = ['service'];

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: [{ data: [0, 0, 0, 0], label: 'Services' }],
  };

  public barChartColors: object[] = [];

  public barChartOptions: ChartConfiguration<'bar'>['options'];

  public backgroundColor = [];
  public borderColor = [];

  constructor(
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private ChartsService: ChartsService,
    private CalendarService: CalendarService,
    // private googleAnalytics: GoogleAnalytics,
    private router: Router
  ) {
    this.stats = [];
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'category', header: 'Category' },
      { field: 'numOfSold', header: '# Sold' },
      { field: 'total', header: '$ Sold' },
    ];


    for (let i = 0; i < 10; i++) {
      const r = Utilities.colorSpectrumRGB[i][0];
      const g = Utilities.colorSpectrumRGB[i][1];
      const b = Utilities.colorSpectrumRGB[i][2];

      this.backgroundColor.push(`rgba(${r}, ${g}, ${b}, 0.8)`);
      this.borderColor.push(`rgba(${r}, ${g}, ${b}, 1)`);
    }

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      this.readOnlyStylistPicker = !(
        user.isAdministrator() || user.getCanViewReports() === 1
      );
    }
  }

  public ngOnInit() {
    // this.googleAnalytics.trackView('ServiceReportPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }
    const currency = this.userService.getSalon().getCurrency();

    this.barChartOptions = {
      scales: {
        x: {
          title: {
            display: true,
            text: 'Different Category in Services',
          },
        },

        y: {
          ticks: {
            callback: function (value, index, values) {
              return Utilities.decodeHTML(currency) + value;
            },
          },
        },
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: (context) => {
              return (
        
                context.dataset.label +
                ': ' +
                context.parsed.y +
                Utilities.decodeHtml(this.userService.getSalon().getCurrency())
              );
            },
          }
        },
      },
    };
  }
  public ngAfterViewInit() {
    if (this.stylist) {
      this.loadStats(this.stylist, this.startDate, this.endDate);
    }
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.timeManager(dateRange.start, dateRange.end);
    this.loadStats(this.stylist, this.startDate, this.endDate);
  }

  public loadStats(stylist: Stylist, startDate: Date, endDate: Date) {
    this.timeManager(startDate, endDate);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    let tempWordCloudData: CloudData[] = [];
    this.reportService
      .loadServiceStats(stylist.id, startDate, endDate)
      .subscribe({
        next: (rows) => {
          this.stats = rows;
          this.isLoading = false;
          let barChartData: Array<{ data: Array<number>; label: string }> = [];
          let labelDataArray: Array<{
            label: string;
            category: string;
            price: number;
          }> = [];
          let labels: Array<string> = [];
          let categoryLabels: Array<string> = [];

          this.stats.forEach((stat) => {
            const label = stat.name;
            if (labels.indexOf(label) === -1) {
              labels.push(label);
              labelDataArray.push({
                label,
                category: stat.category,
                price: stat.total,
              });
              if (categoryLabels.indexOf(stat.category) === -1) {
                categoryLabels.push(stat.category);
              }
            }

            tempWordCloudData.push({
              text: stat.name,
              weight: stat.numOfSold,
              rotate: 45 * Utilities.returnRand(3),
              color: Utilities.colorSpectrum[Utilities.returnRand(6)],
            });
          });
          labelDataArray.forEach((labelData) => {
            barChartData.push({
              data: new Array(categoryLabels.length).fill(0),
              label: labelData.label,
            });
            barChartData[barChartData.length - 1].data[
              categoryLabels.indexOf(labelData.category)
            ] = labelData.price;
          });
          this.barChartLabels = categoryLabels;
          if (barChartData.length > 10) {
            this.barChartData.datasets = barChartData.slice(0, 10);
          } else if (barChartData.length > 0) {
            this.barChartData.datasets = barChartData;
          }
          this.wordCloudData = tempWordCloudData;
          this.barChartData.labels = this.barChartLabels;
          this.barChartData.datasets.forEach((d, index) => {
            d.backgroundColor = this.backgroundColor[index];
            d.borderColor = this.borderColor[index];
          });

          //this.content.resize();
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          // this.content.resize();
        },
      });
  }
  public timeManager(dateRangeStart, dateRangeEnd) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;
  }
  public summaryNumSold() {
    return this.stats
      .map((row) => row['numOfSold'])
      .reduce((res, cell) => (res += cell), 0);
  }

  public summaryTotalSold() {
    return Utilities.roundTo2Decimal(
      this.stats
        .map((row) => row['total'])
        .reduce((res, cell) => (res += Number(cell)), 0)
    );
  }

  public exportPdf() {
    this.export = [
      ...this.stats,
      {
        name: 'Total',
        numOfSold: this.summaryNumSold(),
        total: this.summaryTotalSold(),
      },
    ];
    this.ExportTableService.exportPdf(this.export, 'Services', this.cols);
  }
  public exportExcel() {
    this.export = [
      ...this.stats,
      {
        name: 'Total',
        category: '',
        numOfSold: this.summaryNumSold(),
        total: this.summaryTotalSold(),
      },
    ].map((stat) => {
      return {
        name: stat.name,
        category: stat.category,
        numOfSold: stat.numOfSold,
        total: stat.total,
      };
    });
    this.ExportTableService.exportExcel(
      this.export,
      'Services',
      this.cols.map((col) => col.header)
    );
  }

  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/reports');
  }
}
